import { LOCATION_ROUTES } from '../locationPages';

export const replaceTextContentTemplate = (content, categoryName) => {
  if (!content) return null;
  if (!categoryName) return content;

  const placeholder = LOCATION_ROUTES.CATEGORY_NAME_PLACEHOLDER;

  const updatedContent = { ...content };

  if (updatedContent.headline) {
    updatedContent.headline = updatedContent.headline.replaceAll(
      placeholder,
      categoryName
    );
  }

  if (updatedContent.columns && Array.isArray(updatedContent.columns)) {
    updatedContent.columns = updatedContent.columns.map(column => ({
      ...column,
      content: column.content
        ? column.content.replaceAll(placeholder, categoryName)
        : column.content,
    }));
  }

  return updatedContent;
};
